import i18n from "../../i18n";

export function getProductGroupDefaultType() {
    return Object.freeze({
        "all-products": {
            key: "all-products",
            label: i18n.t('product-group.all-products')
        },
        "empties": {
            key: "empties",
            label: i18n.t('product-group.empties')
        },
        "trade-returns": {
            key: "trade-returns",
            label: i18n.t('product-group.trade-returns')
        },
        "samples": {
            key: "samples",
            label: i18n.t('product-group.samples')
        }
    })
}